import { useCallback } from "react";
import moment from "moment";
import dayjs from "dayjs";

const useDateFormat = () => {
  const user = localStorage.getItem("user");
  const getFormatFromLocalStorage = () => {
    if (user !== null && user !== undefined) {
      const format = JSON.parse(user)?.dateFormat;
      if (format) return format;
      else return "DD/MM/YYYY";
    } else {
      return "DD/MM/YYYY";
    }
  };

  const formatDate = useCallback((date, displatTime, handleInDayjs) => {
    const format = getFormatFromLocalStorage();
    const pad = (num) => num.toString().padStart(2, "0");

    const userData = JSON.parse(user);
    console.log(userData?.timeFormat, "timeformat");
    if (userData?.timeFormat === "24" && displatTime == true) {
      return handleInDayjs !== undefined
        ? dayjs(date).format(`${format} HH:mm`)
        : moment(date).format(`${format} HH:mm`);
    } else if (userData?.timeFormat === "24" && displatTime == false) {
      return handleInDayjs !== undefined && handleInDayjs === true
        ? dayjs(date).format(`${format}`)
        : moment(date).format(`${format}`);
    } else if (userData?.timeFormat === "12" && displatTime == false) {
      return handleInDayjs !== undefined && handleInDayjs === true
        ? dayjs(date).format(`${format}`)
        : moment(date).format(`${format}`);
    } else if (userData?.timeFormat === "12" && displatTime == true) {
      return handleInDayjs !== undefined
        ? dayjs(date).format(`${format} hh:mm a`)
        : moment(date).format(`${format} hh:mm a`);
    }
  }, []);

  // Return both the format string and the formatting function
  return {
    formatDate,
    format: getFormatFromLocalStorage(),
  };
};

export default useDateFormat;
